<template>
  <div v-if="plan" class="premium-card">
    <div class="header">
      <h2 class="title">{{ plan.title }}</h2>
      <span class="tag">{{ plan.label }}</span>
    </div>

    <p class="description">{{ plan.description }}</p>

    <ul class="features">
      <li v-for="f in plan.features" :key="f">{{ f }}</li>
    </ul>

    <p class="price">{{ plan.price }}</p>

    <button class="renew" @click="$emit('renew')">
      Продлить подписку
    </button>
  </div>

  <!-- Если план не найден — показываем fallback -->
  <div v-else class="premium-card">
    <p style="opacity:0.6;">Не удалось определить тип подписки</p>
  </div>
</template>

<script setup>

import { computed } from "vue";

import PremiumPlansFactory from "../../models/PremiumPlansFactory.js";

defineEmits(["renew"]);

const props = defineProps({
  premium: Object
});

// → получаем план по типу
const plan = computed(() => {
  if (!props.premium || !props.premium.activePlan) {
    return null;
  }
  return PremiumPlansFactory.byType[props.premium.activePlan] || null;
});

</script>

<style scoped>
/* Карточка */
.premium-card {
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  padding: 28px;

  background: linear-gradient(135deg, #eaf1ff, #f7faff);
  border-radius: 30px; /* ← более закруглённые углы */
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);

  display: flex;
  flex-direction: column;
  gap: 14px; /* уменьшили вертикальные отступы */

  transition: background 0.3s ease;
}

html[data-theme="dark"] .premium-card {
  background: linear-gradient(135deg, #2f2f33, #3a3b3f);
  box-shadow: 0 8px 24px rgba(0,0,0,0.4);
}

/* Заголовок */
.header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title {
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  color: #121212;
}

html[data-theme="dark"] .title {
  color: #fff;
}

.tag {
  background: #8c52ff;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 28px;
}

/* Описание */
.description {
  margin: 0;
  font-size: 15px;
  font-weight: 600; /* ← жирнее */
  color: #333;
  line-height: 1.35;
}

html[data-theme="dark"] .description {
  color: #ccc;
}

/* Фичи */
.features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.features li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 4px; /* ← было 8px — уменьшил */
  font-size: 14px; /* чуть компактнее */
  color: #333;
  line-height: 1.3;
}

html[data-theme="dark"] .features li {
  color: #e6e6e6;
}

.features li::before {
  content: "✔";
  color: #4facfe;
  position: absolute;
  left: 0;
  top: 0;
  font-weight: bold;
  font-size: 13px;
}

/* Цена */
.price {
  font-weight: 700;
  font-size: 18px; /* чуть меньше, чтобы всё выглядело компактнее */
  margin: 6px 0 4px 0;
  color: #111;
}

html[data-theme="dark"] .price {
  color: #fff;
}

/* Кнопка */
.renew {
  width: 100%;
  padding: 12px 0; /* уменьшил чуть */
  background: linear-gradient(90deg, #4facfe, #8c52ff);
  color: #fff;

  border: none;
  border-radius: 16px;

  font-size: 15px;
  font-weight: 600;

  cursor: pointer;
  transition: 0.2s ease;
}

.renew:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}
</style>